module.exports = __webpack_public_path__ + "11d3030a6ff5dcc3b3841e97bbb7be04.svg";